import React, {useCallback} from 'react';
import {Container} from "../ui/Container";
import {Card} from "@mui/material";
import {AppField} from "../ui/AppField";
import {AppButton} from "../ui/AppButton";
import {makeStyles} from "@mui/styles";
import {useFormik} from "formik";
import {object, string} from "yup";
import {useHistory, useParams} from "react-router";
import {useI18n} from "../../i18n/I18nContext";
import {showError} from "../../utils/NotificationUtils";
import {useIntegrationsContext} from "../../api/integrations/IntegrationsContext";
import {Routes} from "../../constants/Routes";
import {pathParams} from "path-params";

const validationSchema = (translate: any) => object({
    name: string().required(translate("REQUIRED")),
    noun: string().required(translate("REQUIRED")),
    code: string().required(translate("REQUIRED")),
    description: string().required(translate("REQUIRED")),
    directions: string(),
    visibility: string()
});

const useStyles = makeStyles(() => ({
    root: {
        padding: 24
    },
    cardRoot: {
        padding: 24,
        borderRadius: "16px !important" as any
    },
    formTitle: {
        fontSize: 18,
        lineHeight: "21px",
        fontWeight: 700,
        color: "#000",
        marginBottom: 16
    },
    fieldRoot: {
        marginBottom: 24
    }
}));

interface Props {
    readonly isTrigger?: boolean
}


export function IntegrationEventsAdd({isTrigger}: Props) {
    const classes = useStyles();
    const params: any = useParams();
    const {translate} = useI18n();
    const {IntegrationsApi} = useIntegrationsContext();
    const history = useHistory();

    const handleSubmit = useCallback((values) => {
        IntegrationsApi.IntegrationEventsAdd(`/${isTrigger ? "trigger" : "action"}/create`, {...values}).then((res) => {
            history.push(pathParams(isTrigger
                ? Routes.IntegrationEditorTriggerEditor
                : Routes.IntegrationEditorActionsEditor,
                {
                    id: params.id,
                    triggerId: res.payload.id,
                    actionId: res.payload.id
                }))
        }).catch(err => {
            showError(err)
        })
    }, [IntegrationsApi, params, history, isTrigger]);

    const formik = useFormik({
        initialValues: {
            code: "",
            description: "",
            directions: "",
            integrationId: params.id,
            name: "",
            noun: "",
            visibility: "IMPORTANT"
        },
        validationSchema: validationSchema(translate),
        onSubmit: (values) => handleSubmit(values),
    });
    return (
        <div className={classes.root}>
            <Container>
                <Card className={classes.cardRoot}>
                    <h2 className={classes.formTitle}>Add Event</h2>
                    <form onSubmit={formik.handleSubmit}>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                required={true}
                                variant="outlined"
                                labelText="Code"
                                name="code"
                                id="code"
                                error={formik.touched.code && Boolean(formik.errors.code)}
                                helperText={formik.touched.code && formik.errors.code}
                                value={formik.values.code}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                required={true}
                                variant="outlined"
                                labelText="Name"
                                name="name"
                                id="name"
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                                value={formik.values.name}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                required={true}
                                variant="outlined"
                                labelText="Noun"
                                name="noun"
                                id="noun"
                                error={formik.touched.noun && Boolean(formik.errors.noun)}
                                helperText={formik.touched.noun && formik.errors.noun}
                                value={formik.values.noun}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                required={true}
                                variant="outlined"
                                labelText="Description"
                                name="description"
                                id="description"
                                error={formik.touched.description && Boolean(formik.errors.description)}
                                helperText={formik.touched.description && formik.errors.description}
                                value={formik.values.description}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                variant="outlined"
                                labelText="Directions"
                                name="directions"
                                id="directions"
                                error={formik.touched.directions && Boolean(formik.errors.directions)}
                                helperText={formik.touched.directions && formik.errors.directions}
                                value={formik.values.directions}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <div className={classes.fieldRoot}>
                            <AppField
                                fullWidth
                                variant="outlined"
                                labelText="Visibility"
                                name="visibility"
                                id="visibility"
                                error={formik.touched.visibility && Boolean(formik.errors.visibility)}
                                helperText={formik.touched.visibility && formik.errors.visibility}
                                value={formik.values.visibility}
                                onChange={formik.handleChange}
                            />
                        </div>
                        <AppButton type="submit">Save</AppButton>
                    </form>
                </Card>
            </Container>
        </div>
    );
}

